/**
 * Created by dx.yang on 2017/3/20.
 */


import * as imageConst from './constants';


export default {
    [imageConst.getImages](state, data) {
        state.list = data.ImagesSet;
        state.total = data.ImageCount;
    },
    [imageConst.imagePlatforms](state, data) {
        state.imgsys = data;
    },
    //选中的tag和属性项
    [imageConst.colsChecked](state, res) {
        state.listChecked = res.listChecked;
        state.tagsChecked = res.tagsChecked;
    },
};
